module.exports = __webpack_public_path__ + "static/img/iphone3.d5f215a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/iphone/iphone3.png
// module id = Vf4W
// module chunks = 0